// React Libraries
import React from 'react';
import reactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { DefaultThemeProvider } from '@ff/ui';
import zIndices from 'client/utils/zIndices';

// styles
import 'normalize.css';
import './styles/index.css';

// Components
import App from './App';
import apolloClient from './apollo/client';
import ErrorBoundary from './components/ErrorBoundary';
import customizedLightTheme, { customizedDarkTheme } from './utils/customizedThemeForV3Configurator';
import type { Theme } from '@ff/ui/styles/theme';
import useIsDarkMode from '@ff/ui/utils/useIsDarkMode';

// HMR
if ((module as any).hot) {
  (module as any).hot.accept();
}

const AppConfiguration = () => {
  const isDarkMode = useIsDarkMode();

  return (
    <ErrorBoundary>
      <DefaultThemeProvider
        zIndices={{
          modal: zIndices['modal'],
          tooltip: zIndices['tooltip'],
          menubar: zIndices['menubar'],
          menubarDrawer: zIndices['menubarDrawer']
        }}
        customizedTheme={ (isDarkMode ? customizedDarkTheme : customizedLightTheme) as Theme }//TODO: remove this parameter to apply the default theme
      >
        <ApolloProvider client={apolloClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ApolloProvider>
      </DefaultThemeProvider>
    </ErrorBoundary>
  );
};

reactDOM.render(<AppConfiguration />, document.getElementById('root'));
